module.exports = __webpack_public_path__ + "static/media/pauseSvg.8878d5a4.svg";